/**
 * Type guard that checks if a value is a non-null object.
 * Use this as the first check in validatePayload implementations.
 */
export function isNonNullObject(value: unknown): value is object {
  return typeof value === 'object' && value !== null;
}
